import React from 'react'

import Flex from './Flex'
import Box from './Box'

const HighlightNumber = ({
  number,
  numberProps,
  unitProps,
  pre,
  children,
  ...props
}) => {
  return (
    <Flex alignItems="center" {...props}>
      {pre}
      <Box
        ml={pre && '0.25rem'}
        mr="0.25rem"
        style={{ WebkitTextStroke: '0.025em black' }}
        mb="0.25em"
        fontWeight={`black`}
        {...numberProps}
      >{number}</Box>
      <Box {...unitProps}>{children}</Box>
    </Flex>
  )
}

export default HighlightNumber
